export function reduceQueue(state, action) {
  switch (action.type) {
    case 'QUEUE_ENQUEUE':
      {
        const id = String(state.queueIdCounter + 1);
        return Object.assign({}, state, {
          queueIdCounter: state.queueIdCounter + 1,
          messageQueue: [...state.messageQueue, {
            id,
            content: action.content
          }]
        });
      }
    case 'QUEUE_DEQUEUE':
      {
        if (state.messageQueue.length === 0) return state;
        return Object.assign({}, state, {
          messageQueue: state.messageQueue.slice(1)
        });
      }
    case 'QUEUE_REMOVE':
      {
        const idx = state.messageQueue.findIndex(m => m.id === action.id);
        if (idx === -1) return state;
        return Object.assign({}, state, {
          messageQueue: [...state.messageQueue.slice(0, idx), ...state.messageQueue.slice(idx + 1)]
        });
      }
    case 'QUEUE_RESTORE_FAILED':
      return Object.assign({}, state, {
        messageQueue: [action.item, ...state.messageQueue]
      });
    case 'QUEUE_CLEAR':
    case 'RESET':
      return Object.assign({}, state, {
        messageQueue: []
      });
    default:
      return state;
  }
}